module.exports = __webpack_public_path__ + "static/media/Acrilico (35).ed6e32f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Acrilico/Acrilico (35).jpg
// module id = 303
// module chunks = 0